function displayHeader(condition){
  if (condition) {
    $('.following-header-element .navbar').show();
    if($(window).width() < 992){
      $('.following-header-element').addClass("deployed");
  }
} else {
  $('.following-header-element .navbar').hide();
  if($(window).width() < 992){
      $('.following-header-element').removeClass("deployed");
  }
}
}

function normalHeader() {
  let threshold = 65;
  displayHeader($(this).scrollTop() > threshold)
}

function homeHeader(){
  var elementTop = $(".home-top-button-header").offset().top;
  var elementBottom = elementTop + $(".home-top-button-header").outerHeight();

  var viewportTop = $(window).scrollTop();
  
  displayHeader(elementBottom < viewportTop)
}